import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e40fe78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-legend" }
const _hoisted_2 = {
  id: "v-for-object",
  class: "flex-wrap list-unstyled d-flex gap-md-4 gap-3"
}
const _hoisted_3 = { class: "season-legend__item" }
const _hoisted_4 = { class: "season-legend__item-text" }
const _hoisted_5 = {
  key: 0,
  class: "mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasons, (key, value) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass('season season--' + value)
          }, null, 2),
          _createElementVNode("span", _hoisted_4, _toDisplayString(key), 1)
        ]))
      }), 256))
    ]),
    (_ctx.showDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.translate('shop.ticket.* Prices refer to adult day tickets')), 1))
      : _createCommentVNode("", true)
  ]))
}